import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[agsStepperHost]'
})
export class StepperDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
